var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"bounce"}},[_c('div',{staticClass:"main_bg",class:{'hidden': !_vm.visible}},[_c('i',{class:[_vm.typ]},[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),_c('i',{staticClass:"icon-tuichu",on:{"click":_vm.closeToast}},[_vm._v("X")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08c82548","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/message.vue
// module id = null
// module chunks = 